const variables = {
    //dev on local
    //API_URL : 'https://localhost:7234/api/'


    //dev on server
   //PI_URL : 'https://jobapplyapi.csigroups.com:443/api/'

    //live
    API_URL : 'https://jobapplyapi.csigroups.com/api/'
}



export default variables;